import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

import useLineLiff from 'hooks/LineLiff';

const LexusPnpPage = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const pnpId = searchParams.get('pnp');
  const liffState = searchParams.get('liff.state');

  const { liff, userInfo } = useLineLiff(process.env.REACT_APP_LIFF_ID_PNP);

  useEffect(() => {
    if (liffState || !userInfo) return;

    const idToken = liff.getIDToken();

    const processPnp = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/pnp/${pnpId}?line_id_token=${idToken}`
        );

        if (response.data?.success === true) {
          window.location.href = response.data.data.redirect_url;
        } else {
          throw new Error();
        }
      } catch (error) {
        console.error('Error fetching pnp data.');
        navigate('/Error404');
      }
    };

    processPnp();
  }, [liff, userInfo, liffState, pnpId]);

  return <div>redirecting...</div>;
};

export default LexusPnpPage;
